
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Templates allow you to quickly create web pages and websites that are in line with the European Commission's corporate guidelines.`}</p>
    <p>{`Standard presentation ensures a "corporate image" for the Commission which provides a coherent look to the web presence. It also makes things easier for the user through`}</p>
    <ul>
      <li parentName="ul">{`standard elements with a consistent appearance and position on every page that provide the same functions throughout the site at all levels`}</li>
      <li parentName="ul">{`"vertical" and "horizontal" navigational aids (for example, between languages)`}</li>
    </ul>
    <p>{`The standard template must be used for all new development and can also be introduced on existing pages to replace a previous template, but this should be done on a site basis, not page by page.`}</p>
    <p>{`The pages using this template must contain at least all the elements shown in the mandatory version.`}</p>
    <p>{`Mandatory components: site header, page header, feedback form, and corporate footer.`}</p>
    <p><img parentName="p" {...{
        "src": "https://inno-ecl.s3.amazonaws.com/media/images/EC/Templates/Standard/basic_ec_template.jpg",
        "alt": "Standard EC Template"
      }}></img></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;